<template>
  <span>
    <span v-if="expireTime && isActive"
      >有 {{ expireTime }} 证书即将过期，还剩
      <span :class="{ active: isActive }"
        >{{ day }}天{{ hour }}:{{ min }}:{{ second }}</span
      ></span
    >
    <span v-if="expireTime && !dateShow"
      >有 {{ expireTime }} 证书
      <span style="color: red">已过期</span>，请去更新</span
    >
    <span
      v-if="dateShow && !expireTime"
      class="Date"
      :class="{ active: isActive }"
      style=""
    >
      {{ day }}天{{ hour }}:{{ min }}:{{ second }}
    </span>
    <span v-if="!dateShow && !expireTime" style="color: red"> 已到期 </span>
  </span>
</template>

<script setup>
import { defineProps, onBeforeUnmount, onMounted, ref, watch } from "vue";

const props = defineProps({
  endTime: {
    type: String,
    default: "",
  },
  expireTime: {
    type: String,
    default: "",
  },
});

const day = ref("");
const hour = ref("");
const min = ref("");
const second = ref("");
const dateShow = ref(false);
const isActive = ref(false);

let timeout = null;
watch(
  () => props.endTime,
  () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    countTime();
  }
);
onMounted(() => {
  countTime();
});
onBeforeUnmount(() => {
  clearTimeout(timeout);
});
function countTime() {
  // 获取当前时间
  let date = new Date();
  let now = date.getTime();
  // 设置截止时间
  let endDate = new Date(props.endTime);
  let end = endDate.getTime();
  // 时间差
  let leftTime = end - now;
  // 定义变量 d,h,m,s保存倒计时的时间
  let d, h, m, s;
  if (leftTime >= 0) {
    // 天
    d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
    // 时
    h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
    // 分
    m = Math.floor((leftTime / 1000 / 60) % 60);
    // 秒
    s = Math.floor((leftTime / 1000) % 60);

    dateShow.value = true;
    if (d <= 30) {
      isActive.value = true;
    } else {
      isActive.value = false;
    }
  } else {
    dateShow.value = false;
  }
  // 等于0的时候不调用
  if (h === 0 && d === 0 && m === 0 && s === 0) {
    return;
  } else {
    day.value = d.toString();
    hour.value = format(h);
    min.value = format(m);
    second.value = format(s);
    // 递归每秒调用countTime方法，显示动态时间效果,
    timeout = setTimeout(countTime, 1000);
  }
}

function format(n) {
  return n < 10 ? "0" + n : n;
}
</script>

<style scoped>
.active {
  color: red;
}
</style>
